import React, { useState } from "react";
import {
  AdvSeparator,
  Button,
  EmployeeHeader,
  NewTab,
  PageHeader,
  PageTab,
  StatusTags,
} from "../../../../components";
import Placement from "./Placements/Placements";
import AddclientPlacement from "./AddClientPlacement/AddclientPlacement";
import AddPermanentPlacement from "./AddPermanentPlacement/AddPermanentPlacement";
import { addCurrentPlacement } from "../../../../redux/slices/placements/placementsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

const Placements = () => {
  const dispatch = useDispatch();
  const [editData, setEditData] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(() => {
    const searchParams = new URLSearchParams(location.search);
    const placementParam = searchParams.get("placements");
    if (placementParam === "add-permanent-placement") return "AddPermanentPlacement";
    if (placementParam === "add-client-placement") return "AddClientPlacement";
    return null;
  }); // Track current page
  const { placements: placementsTableData, currentPlacement } = useSelector(
    (state) => state.placement,
  );

  React.useEffect(() => {
    // If mounting with "add" parameters in the URL, clear any stale Redux data
    const searchParams = new URLSearchParams(location.search);
    const placementParam = searchParams.get("placements");
    if (placementParam === "add-permanent-placement" || placementParam === "add-client-placement") {
      dispatch(addCurrentPlacement({}));
      setEditData(null);
    }
  }, []); // Run only on mount
  const handleBackClick = () => {
    setCurrentPage(null); // Reset to show PageTab
    //navigate("/employee/employee-profile#work-authorization");
    navigate(
      "/employee/employee-profile?profile-info=work-authorization&work-authorization-main=overview",
    );
  };
  const handleNavigation = (page) => {
    setCurrentPage(page);
  };
  const handleSelect = (data) => {
    setCurrentPage(data);
    dispatch(addCurrentPlacement({}));
    setEditData(null);
  };
  const handleEditPlacement = (row) => {
    setEditData(row);
    const type =
      row?.type === 1
        ? "AddClientPlacement"
        : row?.type === 2
          ? "AddPermanentPlacement"
          : "";
    setCurrentPage(type);
    dispatch(addCurrentPlacement({}));
  };
  const mainPlacementMenus = [
    {
      title: "Placements",
      page: <Placement onEdit={handleEditPlacement} />,
      type: "main",
      icon: "business_center",
    },
    {
      title: "Add Client Placement",
      page: (
        <AddclientPlacement
          onCancel={() => handleNavigation(null)}
          editData={editData}
        />
      ),
      type: "sub",
      icon: "add",
      action: () => handleSelect("AddClientPlacement"),
      //likeMain: true,
    },
    {
      title: "Add Permanent Placement",
      page: (
        <AddPermanentPlacement
          onCancel={() => handleNavigation(null)}
          editData={editData}
        />
      ),
      type: "sub",
      icon: "add",
      action: () => handleSelect("AddPermanentPlacement"),
      //likeMain: true,
    },
    {
      title: "Reports",
      page: "",
      type: "sub",
    },
  ];

  const getCurrentPageComponent = () => {
    switch (currentPage) {
      case "AddClientPlacement":
        return (
          <AddclientPlacement
            onCancel={() => handleNavigation(null)}
            currentPlacement={currentPlacement}
            editData={editData}
          />
        );
      case "AddPermanentPlacement":
        return (
          <AddPermanentPlacement
            onCancel={() => handleNavigation(null)}
            currentPlacement={currentPlacement}
            editData={editData}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="mt-3 flex-1 flex flex-col gap-2 overflow-hidden ">
      <div>
        <PageHeader
          Section={<EmployeeHeader />}
          RightSection={
            <div className="flex gap-3">
              <Button
                color="primary"
                size="sm"
                title={"Back"}
                icon={"west"}
                type="link"
                to="/employee"
              />
              {/* {currentPage && ( */}
              {/* <Button
                size="sm"
                title={"Back"}
                icon={"west"}
                onClick={handleBackClick}
              /> */}
              {/* )} */}
              {/* <Button
                size="sm"
                title={"Next"}
                icon={"east"}
                iconPosition="after"
                //onClick={() => navigate("/employee/employee-profile#documents")}
                onClick={() =>
                  navigate(
                    "/employee/employee-profile?documents=documents&profile-info=documents",
                  )
                }
              /> */}
            </div>
          }
        />
      </div>
      {currentPage ? (
        <div className="flex-1 flex flex-col overflow-hidden ">
          {getCurrentPageComponent()}
        </div>
      ) : (
        <div className="flex-1 flex flex-col overflow-hidden ">
          <NewTab
            tabs={mainPlacementMenus}
            color="black"
            variant="outlined"
            onChange={(tab) => {
              if (tab.action) {
                tab.action();
              }
            }}
            tabLevel="placements"
            mode="url"
            tabId="placements"
          />
        </div>
      )}
    </div>
  );
};

export default Placements;
